import React from 'react';
import AgencyTemplate from '../components/AgencyTemplate';

const NNW = () => {
	const agencyData = {
		title: "Surface Wellhead Services",
		subtitle: "Petrochoice Agent for NNW Inc.",
		description: "Petrochoice is an agent for NNW Inc., a Louisiana-based oil and gas service company founded in 1984 with more than 40 years of experience in surface wellhead services. NNW provides qualified wellhead service technicians to energy-sector partners across the Gulf region and beyond, covering everything from wellhead installation and valve servicing to hot tapping, hydrostatic testing, and slot recovery — all delivered under a strict commitment to safety, quality, and service.",
		image: "/assets/nnw-logo.png",
		imageAlt: "NNW Inc. logo",
		features: [
			{
				title: "What They Do",
				description: "NNW specializes in surface wellhead services performed under live-well conditions. Their technicians handle wellhead and valve maintenance, gate valve drilling, hot and cold tapping, fluid recovery, sealant injection, and pressure-critical interventions that keep production online while work is carried out safely.",
				icon: "bi bi-tools",
				iconColor: "#0c61c0"
			},
			{
				title: "Company History & Reach",
				description: "Founded in 1984 and headquartered in Gonzales, Louisiana, NNW has served the energy sector for over four decades. The company is a certified Woman-Owned Business Enterprise (WBENC) and Woman-Owned Small Business (WOSB), and maintains compliance registrations including Veriforce, Avetta, ISN, and DISA. Its service footprint covers the Gulf of Mexico, the Gulf South region, and the Pacific.",
				icon: "bi bi-geo-alt",
				iconColor: "#28a745"
			}
		],
		additionalSections: [
			{
				title: "Core Service Offering",
				items: [
					[
						{ icon: "bi bi-wrench-adjustable", iconColor: "#dc3545", title: "Wellhead Installation & Maintenance", description: "Procurement, installation, and ongoing maintenance of surface wellhead equipment" },
						{ icon: "bi bi-sliders", iconColor: "#6c757d", title: "Wellhead & Valve Services", description: "Valve repair, sealant injection, and gate valve drilling on live wells" }
					],
					[
						{ icon: "bi bi-droplet-half", iconColor: "#007bff", title: "Hot Tapping & Fluid Recovery", description: "Hot and cold tapping plus controlled fluid recovery without shutting in production" },
						{ icon: "bi bi-speedometer2", iconColor: "#17a2b8", title: "Testing & Torquing", description: "Hydrostatic testing, torquing, and hot bolting to verified pressure specifications" }
					],
					[
						{ icon: "bi bi-arrow-repeat", iconColor: "#fd7e14", title: "Slot Recovery & Workover", description: "Slot recovery and workover support to bring idle wellbores back into service" },
						{ icon: "bi bi-clipboard-check", iconColor: "#20c997", title: "Surveys & Equipment Rental", description: "Wellsite surveys and rental of specialised wellhead service equipment" }
					]
				]
			}
		]
	};

	return <AgencyTemplate {...agencyData} />;
};

export default NNW;
